
import {Text} from "../../../lib/prm/text";
import {Name} from "../../../lib/prm/name";
import {OptionMenu} from "../../../lib/prm/option-menu";
import {ProxyDocumentDelivery} from "../../../lib/docusign-constants";
import {sprintf} from "sprintf-js";

const FIRST_NAME = new Text(new Name("FIRST_NAME"));
const LAST_NAME = new Text(new Name("LAST_NAME"));
const EMAIL = new Text(new Name("EMAIL"));

const ACCOUNT_NUMBER = new Text(new Name("ACCOUNT_NUMBER"));

const ACCOUNT_NUMBERS = [...Array(10).keys()].map(i => {
  return new Text(new Name(sprintf("ACCOUNT_NUMBER_%d", i))) });
const NUM_ACCT = new Text(new Name("NUM_ACCT"), "1");

const ENVELOPE_ID = new Text(new Name("ENVELOPE_ID"));
const ELECTRONIC_SIGNING_TYPE = new OptionMenu(
  new Name("ELECTRONIC_SIGNING_TYPE"),
  [
    new Name(ProxyDocumentDelivery.MAIL_OUT, "Envelope to be emailed to recipient"),
    new Name(ProxyDocumentDelivery.SIGNED, "Envelope has already been signed"),
    new Name(ProxyDocumentDelivery.NO_ENVELOPE, "No electronic signing needed"),
  ]);

export { FIRST_NAME, LAST_NAME, EMAIL, ACCOUNT_NUMBER, ACCOUNT_NUMBERS,
  ENVELOPE_ID, ELECTRONIC_SIGNING_TYPE, NUM_ACCT };
